import $ from 'jquery';
import TomSelect from 'tom-select/dist/js/tom-select.complete.min.js';

let fieldsAreInitialized = false;

function attachSelectPlaceholder(tomSelect, select) {
  const placeholderOption = select.querySelector('option[value=""]');

  if (placeholderOption?.selected) {
    tomSelect.clear(true);
  }

  const placeholderText = placeholderOption?.textContent?.trim() || '';
  if (placeholderText) {
    const placeholderEl = document.createElement('span');
    placeholderEl.classList.add('placeholder');
    placeholderEl.textContent = placeholderText;
    tomSelect.control.appendChild(placeholderEl);
  }
}

function initSelects() {
  const selects = document.querySelectorAll(
    'select.custom-select, .gform_wrapper select, .variations_form select, .woocommerce-ordering select'
  );

  if (0 < selects.length) {
    selects.forEach((select) => {
      new TomSelect(select, {
        create: false,
        maxItems: 1,
        controlInput: false,
        onInitialize() {
          attachSelectPlaceholder(this, select);
        },
      });
    });
  }
}

function changeFileUpload() {
  const multiFileUploads = document.querySelectorAll(
    '.gform_fileupload_multifile'
  );
  if (0 < multiFileUploads.length) {
    multiFileUploads.forEach(function (fileUpload) {
      fileUpload.querySelector('.gform_drop_instructions').textContent =
        wp.i18n._x(
          'Drag and drop file to upload',
          'drag and drop instruction',
          'vtx'
        );
    });
  }
}

$(document).on('gform_post_render', function () {
  fieldsAreInitialized = true;
  changeFileUpload();
  initSelects();
});

// ON READY
window.addEventListener('load', function () {
  if (!fieldsAreInitialized) {
    changeFileUpload();
    initSelects();
  }
});

window.addEventListener('facetwp-loaded', () => {
  const facetSelects = document.querySelectorAll(
    '.facetwp-type-sort select, .facetwp-type-pager select'
  );

  if (0 < facetSelects.length) {
    facetSelects.forEach((select) => {
      if (!select.tomselect) {
        new TomSelect(select, {
          create: false,
          maxItems: 1,
          controlInput: false,
          onInitialize() {
            attachSelectPlaceholder(this, select);
          },
        });
      }
    });
  }
});
